export function Footer() {
	return (
		<footer className="border-t border-gray-200 py-4 text-center text-xs text-gray-500">
			<a href="/privacy" className="hover:text-gray-700 hover:underline">
				Privacy Policy
			</a>
		</footer>
	);
}
